import React from 'react';

function ProgressBar({ percentage, color, height }) {
  const barColor = color || (percentage === 100 ? '#009966' : percentage > 0 ? '#f59e0b' : '#e5e7eb');
  return (
    <div className="progress-bar-track" style={{ height: height || '6px' }}>
      <div className="progress-bar-fill" style={{ width: `${percentage}%`, backgroundColor: barColor }}></div>
    </div>
  );
}

export default ProgressBar;
